import React from 'react'
import { connect } from 'react-redux'
import { selectNippo, likeNippo } from '../actions'
import ReactMarkdown from 'react-markdown'
import breaks from 'remark-breaks'

const NippoCell = ({ selectNippo, likeNippo, users, id, userId, nippoData }) => (
  <div className="box" onClick={e => selectNippo(id)}>
    <article className="media">
      <div className="media-left">
        <figure className="image is-32x32">
          <img src={users[nippoData.uid].images.x192} alt={id}/>
        </figure>
      </div>
      <div className="media-content">
        <div className="content">
          <div>
            <strong>{users[nippoData.uid].displayName}</strong> <small>@{users[nippoData.uid].slackName}</small>
            <br />
            <ReactMarkdown
              source={nippoData.text}
              plugins={[breaks]}
            />
          </div>
        </div>
        <nav className="level is-mobile">
          <div className="level-left">
            <a className="level-item has-text-grey-light" aria-label="reply">
              <span className="icon is-small">
                <i className="fas fa-reply" aria-hidden="true"></i>
              </span>
              <p className="nippo-text">
                {nippoData.repliesCount}
              </p>
            </a>
            <a className={nippoData.likes.includes(userId) ? "level-item has-text-danger" : "level-item has-text-grey-light"}
              aria-label="like"
              onClick={e => {e.stopPropagation();likeNippo(id, userId)}}
            >
              <span className="icon is-small">
                <i className="fas fa-heart" aria-hidden="true"></i>
              </span>
              <p>
                {nippoData.likesCount}
              </p>
            </a>
          </div>
          <div className="level-right">
            <p className="created">{nippoData.createdAt}</p>
          </div>
        </nav>
      </div>
    </article>
  </div>
)

export default connect(
  state => ({
    users: state.users,
    userId: state.user.uid
  }),
  { selectNippo, likeNippo }
)(NippoCell)



// WEBPACK FOOTER //
// ./src/components/NippoCell.js